import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import { fixtureLoader } from '@shared/libs/allLoader'
import { Col, Row } from 'react-bootstrap'

const FixturesItems = dynamic(() => import('@shared/components/series/fixturesItems'), { loading: () => fixtureLoader() })
// const Ads = dynamic(() => import('@shared/components/ads'), { ssr: false })

function FixtureData({ data, id, isSeriesShow }) {
  return (
    <Row>
      {data?.map((fixture, i) => {
        return (
          <Col xl={6} key={i} className='mb-4'>
            {/* {i === 1 && (
              <Ads
                id="div-ad-gpt-138639789-Desktop_Fix_ATF"
                adIdDesktop="oneturf2022_Desktop_Fix_ATF_728x90"
                adIdMobile="oneturf2022_Mobile_Fix_ATF_300x250"
                dimensionDesktop={[728, 90]}
                dimensionMobile={[300, 250]}
                mobile
                className="mb-3 text-center"
              />
            )}
            {i === 3 && (
              <Ads
                id="div-ad-gpt-138639789-1646636968-0"
                adIdDesktop="oneturf2022_Desktop_Fix_MID_728x90"
                adIdMobile="oneturf2022_Mobile_Fix_MID_300x250"
                dimensionDesktop={[728, 90]}
                dimensionMobile={[300, 250]}
                mobile
                className="mb-3 text-center"
              />
            )}
            {i === 6 && (
              <Ads
                id="div-ad-gpt-Desktop_Fix_MID2_728x90"
                adIdDesktop="oneturf2022_Desktop_Fix_MID2_728x90"
                adIdMobile="oneturf2022_Mobile_Fix_MID2_300x250"
                dimensionDesktop={[728, 90]}
                dimensionMobile={[300, 250]}
                mobile
                className="mb-3 text-center"
              />
            )} */}
            <FixturesItems fixture={fixture} id={fixture?._id} isSeriesShow />
          </Col>
        )
      })}
    </Row>
  )
}

FixtureData.propTypes = {
  data: PropTypes.array,
  id: PropTypes.string,
  isSeriesShow: PropTypes.bool
}
export default FixtureData
